module.exports = __webpack_public_path__ + "static/img/btn1.e264ac77.png";